import { useEffect } from "react";
export const inputCls = "w-full px-3.5 py-2.5 rounded-xl border border-[rgba(20,40,26,.12)] bg-white text-sm focus:outline-none focus:ring-2 focus:ring-[var(--leaf)]/30";

export function AdminHeading({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold">{title}</h1>
        {subtitle && <p className="text-sm text-[var(--ink-soft)] mt-1">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export function Field({ label, hint, children }) {
  return (
    <label className="block">
      <span className="text-xs font-bold uppercase tracking-wider text-[var(--ink-soft)]">{label}</span>
      <div className="mt-1.5">{children}</div>
      {hint && <span className="text-xs text-[var(--ink-soft)] mt-1 block">{hint}</span>}
    </label>
  );
}

export const Card = ({ className = "", children, ...rest }) => (
  <div className={`bg-white rounded-2xl border border-[rgba(20,40,26,.08)] ${className}`} {...rest}>{children}</div>
);
export const ROLE_LABELS = { super_admin: "Super Admin", editor: "Content Editor", rates_manager: "Rates Manager", support: "Support" };

export function useNoIndex() {
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => m.remove();
  }, []);
}
